<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <app-sub-title
                    text="Servicio de escolta prestado"
                ></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-bodyguard-services-filters @filter="onFilter" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-bodyguard-list
                    :items="services"
                    @changePage="onChangePage"
                    @sort="onSort"
                />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import BodyguardList from "./BodyguardList/BodyguardList";
import bodyguardRepository from "@repositories/bodyguard.repository";
import BodyguardServicesFilters from "../BodyguardServices/BodyguardServicesFilters/BodyguardServicesFilters";

export default {
    name: "bodyguard_page",
    components: {
        appBodyguardList: BodyguardList,
        appBodyguardServicesFilters: BodyguardServicesFilters
    },
    data: () => ({
        services: {},
        page: 1,
        sortBy: "start_date",
        sortDir: "desc",
        filters: {}
    }),
    methods: {
        async loadServices() {
            const br = { ...bodyguardRepository };
            const filters = {
                ...this.filters,
                sortBy: this.sortBy,
                sortDir: this.sortDir
            };
            try {
                const { data } = await br.loadBodyguardServices(
                    filters,
                    this.page
                );
                this.services = data;
            } catch (err) {
                toastr.error(`Ocurrió un error [${err.message}]`);
            } finally {
            }
        },
        initialize() {
            this.loadServices();
        },
        async onFilter(filters) {
            this.page = 1;
            this.filters = filters;
            this.loadServices();
        },
        onChangePage(page) {
            this.page = page;
            this.loadServices();
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDir = ctx.sortDir;
            this.loadServices();
        }
    },
    created() {
        this.initialize();
    }
};
</script>
